module.exports = __webpack_public_path__ + "static/img/9areaA_01.559f650.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/9areaA_01.png
// module id = 956
// module chunks = 1